import { getSystemNotifications } from '../api/system_notifications'
import * as onboardingTypes from '../store/modules/onboarding/types'

export default {
  methods: {

    fetchSystemNotificatons() {
      if(this.authUser && !this.isAdmin) {
        getSystemNotifications().then((res) => {
          this[onboardingTypes.SYSTEM_NOTIFICATIONS](res.data)
        })
      }
    }
  },

  computed: {
    showNotification() {
      return this.systemNotifications.length > 0
    },
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/mixins/systemNotifications.js
// module id = null
// module chunks = 